import React from 'react';
import { Loader2 } from 'lucide-react';

const StateShell = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-gray-50">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">{children}</div>
  </div>
);

export const RiskDetailsLoadingState = () => (
  <StateShell>
    <div className="flex flex-col items-center justify-center">
      <Loader2 className="h-8 w-8 text-blue-600 animate-spin mb-4" />
      <p className="text-sm text-gray-500">Loading risk details...</p>
    </div>
  </StateShell>
);

interface RiskDetailsErrorStateProps {
  onRetry: () => void;
  onBack: () => void;
}

export const RiskDetailsErrorState = ({ onRetry, onBack }: RiskDetailsErrorStateProps) => (
  <StateShell>
    <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3">
      <p className="text-sm text-red-700 mb-3">Failed to load risk details. Please try again.</p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onRetry}
          className="px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
        >
          Retry
        </button>
        <button
          type="button"
          onClick={onBack}
          className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Back to risks
        </button>
      </div>
    </div>
  </StateShell>
);

interface RiskDetailsNotFoundStateProps {
  onBack: () => void;
}

export const RiskDetailsNotFoundState = ({ onBack }: RiskDetailsNotFoundStateProps) => (
  <StateShell>
    <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
      <p className="text-sm text-amber-800 mb-3">Risk not found or it may have been removed.</p>
      <button
        type="button"
        onClick={onBack}
        className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
      >
        Back to risks
      </button>
    </div>
  </StateShell>
);
